import { render, staticRenderFns } from "./StoresModal.vue?vue&type=template&id=99be457c&scoped=true"
import script from "./StoresModal.vue?vue&type=script&lang=ts"
export * from "./StoresModal.vue?vue&type=script&lang=ts"
import style0 from "./StoresModal.vue?vue&type=style&index=0&id=99be457c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99be457c",
  null
  
)

export default component.exports